__turbopack_context__.v({
  "cardBody": "styleConstants-module__d1VfTa__cardBody",
  "cardTitle": "styleConstants-module__d1VfTa__cardTitle",
  "sectionBody": "styleConstants-module__d1VfTa__sectionBody",
  "sectionHeading": "styleConstants-module__d1VfTa__sectionHeading",
  "sectionLabel": "styleConstants-module__d1VfTa__sectionLabel",
  "sectionTextBlock": "styleConstants-module__d1VfTa__sectionTextBlock",
});
